import React, { PropsWithChildren } from "react";
import { Container } from "../container";

export const Quote: React.FC<PropsWithChildren> = ({ children, ...props }) => {
  return (
    <Container {...props} className="grid grid-cols-4 gap-16">
      <div className="hidden lg:col-span-1  lg:flex" />
      <div className="col-span-4 ml-8 mt-4 font-serif text-base leading-tight lg:col-span-3 lg:ml-0 lg:mt-4 lg:text-xl">
        {children}
      </div>
    </Container>
  );
};
